import { gql } from '@apollo/client';

export const GetUserAgentIsReady = gql`
    query getUserAgentIsReady {
        getUserAgentIsReady {
            isReady
            trainingGuide
        }
    }
`;
